
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { extractMessageFromException, getMauticContactId } from '@/utils/helpers'
import analytics from '~/mixins.js/analytics'
import '@/utils/initValidationRules'

export default {
  components: { ValidationProvider, ValidationObserver },
  mixins: [analytics],
  props: { diagram: { type: Object, required: true }, name: { type: String } },
  data () {
    return {
      loading: false,
      email: null,
      message: null,
      termsAndNewsletterAgreement: false,
      zohoCampaignId: null,
      newsletterRequired: true,
      sent: false
    }
  },
  methods: {
    async submitForm () {
      this.loading = true
      try {
        await this.$backend.freeProduct.post({
          email: this.email,
          diagram_id: this.diagram.id,
          message: this.message,
          newsletter_agreement: this.termsAndNewsletterAgreement,
          terms_agreement: this.termsAndNewsletterAgreement,
          mautic_contact_id: getMauticContactId()
        })
        this.trackEvent('Lead', 'Free product', this.diagram.name)
        this.trackEvent('Lead', this.message)
        this.$bing && this.$bing.event(
          {
            event_category: 'Lead',
            event_label: this.diagram.name.slice(0, 50)
          },
          'submit_lead_form'
        )
        this.$store.commit('exitOverlay/setOverlayDisplayed')
        this.$emit('submit')
        this.sent = true
      } catch (error) {
        console.log('Error', error)
        this.$toast.error(extractMessageFromException(error))
      } finally {
        this.loading = false
      }
    }
  }
}
